export const modalReservationDirect = {
  header: {
    title: "الحجوزات المباشرة عبر الويب",
    subtitle: "حدّد ما يراه الضيف وكيف تُطبَّق القواعد.",
  },
  tabs: {
    reservations: "حالة الحجز",
    ratePlans: "التعرفات",
    promotions: "العروض",
    addons: "رسوم إضافية",
    payments: "الأسعار والمدفوعات",
    share: "مشاركة",
  },
  common: {
    close: "إغلاق",
    updating: "جارٍ التحديث…",
    hotel: "فندق",
    apartment: "شقة",
    visible: "ظاهر",
    default: "افتراضي",
    dragToReorder: "اسحب لإعادة الترتيب",
    saving: "جارٍ الحفظ…",
    preview: "معاينة",
  },
  toast: {
    successTitle: "نجاح",
  },
  save: {
    ratePlans: "حفظ التعرفات",
    promotions: "حفظ العروض",
    addons: "حفظ الرسوم",
    default: "حفظ",
  },
  reservations: {
    cardTitle: "حالة الحجوزات المباشرة",
    cardDesc: "فعِّل/عطِّل توفّر الحجوزات المباشرة (عامًّا ولكل وحدة).",
    activateTitle: "تفعيل الحجوزات المباشرة",
    activateHelp: "إذا كان معطّلًا، فلن تتمكّن من تفعيل الوحدات بشكل فردي.",
    colName: "مكان الإقامة / الوحدة",
    colCapacity: "السعة",
    colAvailable: "متاح",
    emptyUnits: "لا توجد وحدات مُعدَّة لهذا العقار.",
  },
  ratePlans: {
    title: "التعرفات الظاهرة في الحجز المباشر",
    hotelDesc: "حدّد التعرفات التي تُعرض لكل نوع غرفة",
    apartmentDesc: "حدّد خطط الأسعار التي يراها الضيف، وأيّها الافتراضية والترتيب",
    loading: "جارٍ تحميل التعرفات…",
    emptyApartment: "لا توجد تعرفات مُعدَّة لهذا العقار.",
    emptyHotel: "لا توجد أنواع غرف مُعدَّة لهذا الفندق.",
    emptyRoom: "لا توجد تعرفات مُعدَّة لهذه الغرفة.",
    colTarifa: "التعرفة",
    colVisibleName: "الاسم الظاهر",
    visibleNameTooltip: "اسم اختياري لعرضه للضيف",
    namePlaceholderApartment: "مثال: غير قابلة للاسترداد / مرنة",
    namePlaceholderHotel: "مثال: يشمل الإفطار",
    derivedBadge: "مُشتقّة",
    rulesApartment: "القواعد: تعرفة ظاهرة واحدة على الأقل وواحدة افتراضية (يجب أن تكون ظاهرة).",
    rulesHotel: "يجب أن تحتوي كل غرفة على تعرفة ظاهرة واحدة على الأقل وواحدة افتراضية.",
  },
  rooms: {
    ratesCount: "{count} تعرفة | {count} تعرفات",
    meta: "السعة: {capacity} • البالغون: {adults} • الأطفال: {children}",
  },
  promotions: {
    title: "العروض في الحجز المباشر",
    desc: "تحكّم في العروض التي تُعرض، وهل تُطبَّق تلقائيًّا، وترتيبها.",
    loading: "جارٍ تحميل العروض…",
    empty: "لا توجد عروض مُعدَّة لهذا العقار.",
    colPromo: "العرض",
    colBadge: "شارة",
    badgeTooltip: "نص قصير (مثال: -10%، عرض، Early Bird).",
    colAuto: "تطبيق تلقائي",
    colStackable: "قابلة للتجميع",
    badgePlaceholder: "مثال: -10% / عرض",
    tip: "نصيحة: إذا كنت لا تريد أن يؤثّر عرض ما في السعر النهائي، فعطّل «التطبيق التلقائي» وأبقِه ظاهرًا.",
    fromDate: "من {date}",
    untilDate: "حتى {date}",
  },
  addons: {
    loading: "جارٍ تحميل الإعدادات…",
    subtabOccupancy: "خصم حسب الإشغال",
    subtabExtraGuest: "رسم لكل ضيف إضافي",
    baseOccupancyTitle: "الإشغال الأساسي",
    baseOccupancyDesc: "السعر المعتاد يقابل هذا الإشغال. ولعدد ضيوف أقل تُطبِّق تخفيضًا.",
    guestsLabel: "ضيوف",
    headOccupancy: "الإشغال",
    headRule: "القاعدة",
    headValue: "القيمة",
    headActive: "مُفعَّل",
    guestWord: "ضيف | ضيوف",
    usualPrice: "السعر المعتاد",
    modePercent: "تخفيض %",
    modeFixed: "تخفيض ثابت (لكل ليلة)",
    occupancyExample: "مثال: الأساس 4 ضيوف وخصومات لـ 3 و2 و1.",
    configTitle: "الإعدادات",
    configDesc: "طبِّق رسمًا إضافيًّا لكل ضيف إضافي فوق الإشغال المشمول.",
    activate: "تفعيل",
    includedTitle: "الإشغال المشمول",
    includedDesc: "يُؤخَذ تلقائيًّا حسب سعة مكان الإقامة.",
    maxExtraLabel: "الحد الأقصى للضيوف الإضافيين المسموح بهم",
    maxHelpHtml: "كم عدد الضيوف الذين يمكن إضافتهم <b>فوق الإشغال المشمول</b>.<br />إذا وضعت <b>0</b>، فلا يُسمح بضيوف إضافيين.<br />إذا تركته فارغًا، فلا يوجد حد.",
    chargeTypeLabel: "نوع الرسم",
    chargeTypeFixed: "مبلغ ثابت",
    chargeTypePercentage: "نسبة مئوية",
    chargeTypeHelp: "ثابت: {currency} لكل ضيف إضافي. نسبة مئوية: % من السعر الأساسي.",
    priceLabel: "السعر لكل ضيف إضافي",
    appliesHelp: "يُطبَّق لكل ضيف إضافي.",
    appliesBlockedNote: "(لا يُسمح بضيوف إضافيين عندما يكون الحد الأقصى 0)",
    applicationLabel: "التطبيق",
    applicationNote: "في الوقت الحالي يُطبَّق هذا الرسم لكل ليلة.",
    previewFixed: "يضيف كل ضيف إضافي <b>{amount}</b> لكل ليلة.",
    previewPercent: "يضيف كل ضيف إضافي <b>{percent}%</b> من السعر الأساسي لكل ليلة.",
    singleValueNote: "هذه <b>قيمة واحدة</b> (مثال: +10 {currency} أو +15% لكل ضيف إضافي).",
  },
  payments: {
    title: "الأسعار والمدفوعات",
    desc: "نوع التحصيل والخصومات للحجوزات المباشرة.",
    paymentTypeTitle: "نوع الدفع",
    onArrivalLabel: "الدفع عند الوصول",
    onArrivalDesc: "يحجز الضيف ويدفع مباشرةً عند الوصول.",
    onlineLabel: "الدفع عبر الإنترنت",
    onlineDesc: "يدفع الضيف عبر الإنترنت عند إتمام الحجز.",
    discountsTitle: "الخصومات",
    enableDiscount: "تفعيل الخصم على الحجوزات المباشرة",
    discountTypeTitle: "نوع الخصم",
    typePercentage: "نسبة مئوية",
    typePercentageDesc: "خصم متناسب مع الإجمالي.",
    typeFixed: "ثابت",
    typeFixedDesc: "مبلغ ثابت للخصم.",
    valueTitle: "القيمة",
    placeholderPercentage: "مثال: 10",
    placeholderFixed: "مثال: 15.00",
    helpPercentage: "بحد أقصى 100%. يُطبَّق على الإجمالي.",
    helpFixed: "يُخصَم مبلغ ثابت بـ {currency}.",
    previewPercentage: "سيُطبَّق خصم بنسبة {percent}%.",
    previewFixed: "سيُطبَّق خصم قدره {amount}.",
  },
  share: {
    title: "مشاركة",
    desc: "انسخ رابط الحجز المباشر وشاركه عبر WhatsApp أو افتح عرض الضيف.",
    linkLabel: "رابط الحجوزات",
    linkHelp: "هذا هو الرابط الذي تشاركه مع الضيوف.",
    viewAsGuest: "العرض كضيف",
    tip: "نصيحة: شارك هذا الرابط في نبذتك والرسائل التلقائية والحملات.",
    whatsappMessage: "مرحبًا 👋 أشاركك رابط الحجز: {link}",
  },
  errors: {
    loadRatePlans: "تعذّر تحميل التعرفات.",
    saveRatePlans: "تعذّر حفظ التعرفات.",
    roomMinVisible: 'يجب أن تحتوي الغرفة "{name}" على تعرفة ظاهرة واحدة على الأقل.',
    roomExactlyOneDefault: 'يجب أن تحتوي الغرفة "{name}" على تعرفة افتراضية واحدة بالضبط.',
    roomDefaultMustBeVisible: 'في "{name}"، يجب أن تكون التعرفة الافتراضية ظاهرة.',
    aptMinVisible: "يجب أن تُبقي تعرفة ظاهرة واحدة على الأقل.",
    aptExactlyOneDefault: "يجب أن توجد تعرفة افتراضية واحدة بالضبط.",
    aptDefaultMustBeVisible: "يجب أن تكون التعرفة الافتراضية ظاهرة.",
    loadPromotions: "تعذّر تحميل العروض.",
    savePromotions: "تعذّر حفظ العروض.",
    saveAddons: "تعذّر حفظ الرسوم الإضافية.",
    maxExtraRange: "يجب أن يكون الحد الأقصى للضيوف الإضافيين بين 0 و50 (أو فارغًا = بلا حد).",
    extraPriceInvalid: "يجب أن يكون السعر لكل ضيف إضافي صحيحًا (>= 0).",
    percentRange: "يجب أن تكون النسبة المئوية بين 0 و100.",
    baseOccupancyRange: "يجب أن يكون الإشغال الأساسي بين 1 و{max}.",
    discountValuesInvalid: "يجب أن تكون قيم الخصم أرقامًا صحيحة (>= 0).",
    discountPercentMax: "لا يمكن أن تتجاوز خصومات النسبة المئوية 100.",
    updateFailed: "تعذّر التحديث.",
    updateUnitFailed: "تعذّر تحديث حالة الوحدة.",
    updateGlobalFailed: "تعذّر تحديث الحالة العامة.",
    noLinkCopy: "لا يوجد رابط للنسخ.",
    copyFailed: "تعذّر نسخ الرابط.",
    noLinkShare: "لا يوجد رابط للمشاركة.",
    noLinkOpen: "لا يوجد رابط لفتحه.",
    updatePaymentType: "تعذّر تحديث نوع الدفع.",
    savePayments: "تعذّر حفظ التغييرات.",
  },
  success: {
    ratePlansSaved: "تم حفظ التعرفات بنجاح.",
    promotionsSaved: "تم حفظ العروض بنجاح.",
    addonsSaved: "تم حفظ الرسوم الإضافية بنجاح.",
    updated: "تم التحديث بنجاح.",
    globalUpdated: "تم تحديث الحالة العامة.",
    linkCopied: "تم نسخ الرابط.",
    changesSaved: "تم حفظ التغييرات.",
  },
};
